var _defs, _rect, _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCartonBonnePosition(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "positions_porter_carton",
    "data-name": "positions porter carton",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 491.34 616.36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{stroke:#fff;stroke-miterlimit:10;stroke-width:4px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "bonne r\xE9ponse") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 255.34,
    y: 403,
    width: 236,
    height: 158
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 334.34,
    cy: 79,
    r: 79
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1003,1283l-40-115c9.5-41.88-3.48-64-29-75l13-130c-2-42-47-91-91-70,0,0-212,194-228,210s4.33,117,56,133l111-6-99,91c-16.23,15.45,23.77,57.45,40,42l150.41-122.52L914,1218l47,80C965.29,1310,1007.29,1295,1003,1283ZM863,1100l-72,12,75-60C866,1072,864,1087,863,1100Z",
    transform: "translate(-620.66 -752)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M866,1063.66,863,1121l98,177c4.29,12,46.29-3,42-15l-40-115-29-75,13-130",
    transform: "translate(-620.66 -752)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartonBonnePosition);
export default __webpack_public_path__ + "static/media/carton_bonne_position.c6a8d15f36660a31cd7a361f3b8809d3.svg";
export { ForwardRef as ReactComponent };